document.addEventListener('DOMContentLoaded', () => {
  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => [...c.querySelectorAll(s)];

  qsa('[data-menu-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const drawer = qs('[data-mobile-menu]');
      if (!drawer) return;
      drawer.classList.toggle('is-open');
      document.body.classList.toggle('menu-open');
    });
  });

  qsa('[data-close-menu]').forEach(btn => btn.addEventListener('click', () => {
    const drawer = qs('[data-mobile-menu]');
    if (drawer) drawer.classList.remove('is-open');
    document.body.classList.remove('menu-open');
  }));

  qsa('[data-cart-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const drawer = qs('[data-cart-drawer]');
    if (drawer) drawer.classList.add('is-open');
  }));
  qsa('[data-cart-close]').forEach(btn => btn.addEventListener('click', () => {
    const drawer = qs('[data-cart-drawer]');
    if (drawer) drawer.classList.remove('is-open');
  }));

  qsa('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = qs('[type="submit"]', form);
      if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
      try {
        const res = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify(Object.fromEntries(new FormData(form)))
        });
        if (!res.ok) throw new Error('Cart error');
        window.location.href = '/cart';
      } catch(err) {
        if (btn) { btn.disabled = false; btn.textContent = 'ADD TO CART →'; }
        alert('Could not add this item. Please try again.');
      }
    });
  });

  qsa('[data-gallery-thumb]').forEach(btn => btn.addEventListener('click', () => {
    const img = qs('[data-gallery-main]');
    if (img) img.src = btn.dataset.src;
    qsa('[data-gallery-thumb]').forEach(x => x.classList.remove('is-active'));
    btn.classList.add('is-active');
  }));

  qsa('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime();
    const tick = () => {
      let d = Math.max(0, end - Date.now());
      const days = Math.floor(d/86400000); d%=86400000;
      const hrs = Math.floor(d/3600000); d%=3600000;
      const mins = Math.floor(d/60000); d%=60000;
      const secs = Math.floor(d/1000);
      [['days',days],['hours',hrs],['mins',mins],['secs',secs]].forEach(([k,v]) => {
        const n=qs(`[data-time="${k}"]`,el); if(n) n.textContent=String(v).padStart(2,'0');
      });
    };
    tick(); setInterval(tick,1000);
  });
});

document.addEventListener('click', e => {
  const openBtn = e.target.closest('[data-modal-open]');
  const closeBtn = e.target.closest('[data-modal-close]');
  if (openBtn) {
    const modal = document.querySelector(`[data-modal="${openBtn.dataset.modalOpen}"]`);
    if (modal) { modal.classList.add('is-open'); document.body.classList.add('modal-open'); }
  }
  if (closeBtn || e.target.classList.contains('site-modal__backdrop')) {
    const modal = e.target.closest('.site-modal');
    if (modal) { modal.classList.remove('is-open'); document.body.classList.remove('modal-open'); }
  }
});
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') document.querySelectorAll('.site-modal.is-open').forEach(m => {
    m.classList.remove('is-open'); document.body.classList.remove('modal-open');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.site-header');
  const onScroll = () => { if (header) header.classList.toggle('scrolled', window.scrollY > 8); };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive:true });

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          io.unobserve(entry.target);
        }
      });
    }, { threshold:.08 });
    document.querySelectorAll('.section:not(.hero) .product-card, .section:not(.hero) .collection-card, .section:not(.hero) .social-grid a, .section:not(.hero) .trust-item, .section:not(.hero) .sizes a').forEach(el => {
      el.style.animationPlayState = 'paused';
      io.observe(el);
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const infoModals = [...document.querySelectorAll('[data-info-modal]')];
  const openInfoFromHash = () => {
    const key = window.location.hash.replace('#','');
    infoModals.forEach(m => m.classList.remove('is-open'));
    const modal = infoModals.find(m => m.dataset.infoModal === key);
    if (modal) {
      modal.classList.add('is-open');
      document.body.classList.add('modal-open');
      modal.setAttribute('aria-hidden','false');
    }
  };
  const closeInfo = () => {
    infoModals.forEach(m => { m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); });
    document.body.classList.remove('modal-open');
  };
  document.addEventListener('click', e => {
    const close = e.target.closest('[data-info-close]');
    if (close) closeInfo();
  });
  window.addEventListener('hashchange', openInfoFromHash);
  openInfoFromHash();
});
